const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");

const styles = require("./styles/DevPanels.css");

module.exports = createReactClass({
	displayName: "DevNavSection",

	propTypes: {
		heading: PT.string,
	},

	getInitialState: function() {
		return {
			expanded: false,
		};
	},

	render: function() {
		const isExpanded = this.state.expanded;
		const toggle = () => this.setState({expanded: !isExpanded});
		const expandClass = isExpanded ? styles.expandYes : styles.expandNo;
		const baseEl = (
			<div className={expandClass} onClick={toggle}>
				{this.props.heading} <div className={styles.expandIcon} />
			</div>
		);
		if (!isExpanded) {
			return baseEl;
		}

		return (
			<div className={styles.expandContainer}>
				{baseEl}
				{this.props.children}
			</div>
		);
	},
});
